import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

Vue.component("v-select", vSelect);

// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

import loader from './components/prism/shared/loader'
Vue.component('loader', loader)

import VueLocalStorage from 'vue-localstorage'

import VueFlashMessage from 'vue-flash-message';
Vue.use(VueFlashMessage);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

import CryptoJS from 'crypto-js'
Vue.use(CryptoJS);

import Notifications from 'vue-notification'
Vue.use(Notifications)
import VModal from 'vue-js-modal'
Vue.use(VModal)
import FlipCountdown from 'vue2-flip-countdown'
Vue.component('flip-countdown', FlipCountdown)

import HighchartsVue from 'highcharts-vue'
Vue.use(HighchartsVue)

import VueFeather from 'vue-feather';
Vue.use(VueFeather);

import pdf from 'vue-pdf'
Vue.component('vue-pdf', pdf)

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, { fieldsBagName: 'veeFields' });
// Vue.use(VeeValidate);

import CircularCountDownTimer from "vue-circular-count-down-timer";
Vue.use(CircularCountDownTimer);

import Cropper from 'cropperjs'

import vueShapeImg from 'vueshapeimg'
import JsonCSV from 'vue-json-csv'
import Toasted from 'vue-toasted'
import vuescroll from 'vuescroll'
import VieOtpInput from "@bachdgvn/vue-otp-input"
import VueChatScroll from 'vue-chat-scroll'
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'
Vue.component(VueCropper);
Vue.use(VueChatScroll)
Vue.component("vie-otp-input", VieOtpInput);
Vue.use(vuescroll);

import vueCookies from 'vue-cookies'
Vue.use(vueCookies)

//================paginate=======================
import Paginate from 'vuejs-paginate'
Vue.component('paginate', Paginate)
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);

Vue.component('downloadCsv', JsonCSV)
Vue.config.productionTip = false

Vue.use(Toasted)
Vue.use(VueLocalStorage)
Vue.use(require('vue-moment'))
Vue.use(vueShapeImg)

// window._          = require('../static/prism/js/chartiq.js');

require('vue-flash-message/dist/vue-flash-message.min.css');
require('../static/prism/js/thirdparty/html2canvas.js')
require('../static/prism/js/thirdparty/object-observe.js')
require('../static/prism/js/thirdparty/perfect-scrollbar.jquery.js')

require('../static/prism/js/thirdparty/webcomponents-lite.min.js')
// require('../static/prism/js/chartiq.js')

// window.___      = require('../static/prism/js/addOns.js');

// require('../static/prism/js/symbolLookup.js')

// require('../static/prism/js/translations.js')

// window.__   = require('../static/prism/js/quoteFeedSimulator.js');

Vue.directive('focusdir', {
    inserted: function (el, binding, vnode) {
        if (binding.value) {
	      el.focus();
	    }
    },
    update: function (el, binding, vnode) {
        Vue.nextTick(function() {
          if (binding.value) {
			      el.focus();
			    }
        })
    }
})

Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  /*inserted: function (el) {
    // Focus the element
    el.focus()
  }*/
})

new Vue({
  	el: '#app',
    router,
    store,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js